<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :title="titleSideBar"
    >
      <formCadastro
        slot="form"
        @cancel="addNewDataSidebar = false"
        @concluido="concluido"
        :sideBar="true"
        :dados="dadosSideBar"
        :contadorRender="contadorRender"
      ></formCadastro>
    </add-new-data-sidebar>

    <vs-table
      noDataText="Nenhum Banner Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="inativar">
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="reativar">
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="Banneres.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
            >
              <span class="mr-2">Filtrar por:</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="buscaDados('ativo')">
                <span>Ativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="buscaDados('inativo')">
                <span>Inativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="buscaDados('todos')">
                <span>Todos</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO Banner ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Banner</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Banner ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="nome" v-if="!decoded.idEmpresa">Empresa</vs-th>
        <vs-th sort-key="Nome">Imagem</vs-th>
        <vs-th sort-key="Nome">Imagem Mobile</vs-th>
        <vs-th sort-key="Nome">Link </vs-th>
        <vs-th sort-key="Banner">Ordenação</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td v-if="!decoded.idEmpresa">
              <p class="product-category" v-if="tr.empresa">
                {{ tr.empresa.nomeEmpresa }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                <img :src="tr.banner" width="200" />
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                <img :src="tr.bannerMobile" width="200" />
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.link }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.ordenacao }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div class="vx-col">
                  <vs-button
                    v-tooltip="'Editar Banner'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="openSideBar(tr)"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Banner ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <!------------ END INFORMAÇÕES DO Banner ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../../../Includes/SideBar";
import service from "../../../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "./../../../../components/ModalInfo";
import formCadastro from "./FormBanner.vue";
import jwt from "jsonwebtoken";

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    formCadastro,
    ModalInfo,
  },
  props: ["subjectPermission"],
  data() {
    return {
      idEmpresa: null,
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: "Banners",
      formSideBar: "Banners",
      entidade: "Banner",
      titleSideBar: "Adicionar Banner",
      popupActive: false,
      modalSenha: false,
      modalSelecionado: [],
      itemAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      contadorRender: 0,
      senha: null,
      decoded: service.getDecoded(),
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    verificaAdmin() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == "Super User") this.isAdmin = true;
      }
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idBanner);
        });
        service
          .post(this.controllerGeral, "Inativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro inativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idBanner);
        });
        service
          .post(this.controllerGeral, "Reativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro reativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    buscaDados(filtrarpor = "todos") {
      this.selected = [];
      this.$vs.loading();

      service
        .getAll(
          this.controllerGeral,
          {},
          "Listar/" + filtrarpor + "?idEmpresa=null"
        )
        .then((res) => {
          this.itens = [];
          console.log(res.data);
          res.data.forEach((element) => {
            this.itens.push(element);
          });
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != "createdAt" &&
                element != "updatedAt" &&
                element != "deletedAt" &&
                element.indexOf("id") != 0
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idBanner == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
      this.contadorRender = this.contadorRender + 1;
    },
    openModalSenha(cod) {
      this.itemAlteracao = {};
      this.modalSenha = true;
      this.itemAlteracao = this.itens.find((x) => x.idBanner == cod);
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idBanner == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.addNewDataSidebar = false;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
